<template>
  <UlDialog
    v-model="dialog"
    header-type="information"
    left-header-icon="icons/rodina.svg"
    :title="$t('invitation.title')"
    :mobile-buttons="mobileButtons"
    :loading="invitationLoading"
  >
    <template #text>
      <InvitationContent />
    </template>
  </UlDialog>
</template>

<script>
import invitation from '@/mixins/invitation';
import { mapGetters } from 'vuex';
import UlDialog from '@/components/Atoms/UlDialog';
import InvitationContent from '@/components/Molecules/InvitationContent';

export default {
  name: 'InvitationDialog',
  components: { InvitationContent, UlDialog },
  mixins: [invitation],
  watch: {
    dialog(newValue) {
      if (newValue) {
        if (!this.shareLink) {
          this.getShareLink();
        }

        this.gtmPush({ event: 'invitation', 'event.detail': 'show' });
        this.codeCopied = false;
      }
    }
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'invitation';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    ...mapGetters({
      invitationLoading: 'profile/invitation/invitationLoading'
    }),
    mobileButtons() {
      return [this.invitationMobileButtonSettings];
    }
  }
};
</script>
